import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface TermsAndConditions {
  title: any;
}

interface termsState {
  data: TermsAndConditions[];
  loading: boolean;
  error: string | null;
}

const PORT = import.meta.env.VITE_USERS_PORT;
const MASTERURL = import.meta.env.VITE_API_USERS_URL;

interface ApiResponse {
  data: TermsAndConditions[];
}

export const fetchAllTermsDocuments = createAsyncThunk<
  TermsAndConditions[],
  void,
  { rejectValue: string }
>('TermsAndConditions/fetchTermsAndConditions', async (_, { rejectWithValue }) => {
  try {
    const response = await apiService.get<ApiResponse>('/get_all_terms_documents', PORT, MASTERURL);
    return response.data;
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
  }
});
export const createTermsAndConditions: any = createAsyncThunk(
  'TermsAndConditions/createTermsAndConditions',
  async (params: any, thunkAPI) => {
    console.log(params);
    try {
      const response = await apiService.post(
        'create_terms_and_conditions',
        params,
        PORT,
        MASTERURL,
      );
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const updateTermsAndConditions: any = createAsyncThunk(
  'TermsAndConditions/updateTermsAndConditions',
  async (params: any, thunkAPI) => {
    try {
      const response = await apiService.put('update_diet_type', params, PORT, MASTERURL);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  },
);

export const softDeleteTermsAndConditions: any = createAsyncThunk<
  number, // ✅ return type: deleted id
  number // ✅ argument type: cuisine id
>('TermsAndConditions/deleteTermsAndConditions', async (id) => {
  try {
    const response = await apiService.patch(`soft_delete_diet_type?id=${id}`, {}, PORT, MASTERURL);
    return response;
  } catch (error: any) {
    return error?.message || 'An error occurred while deleting cuisine type';
  }
});

export const termsandconditionsSlice = createSlice({
  name: 'TermsAndConditions',
  initialState: {
    data: [] as TermsAndConditions[],
    loading: false,
    error: null,
  } as termsState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllTermsDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTermsDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAllTermsDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Unknown error';
      })
      .addCase(createTermsAndConditions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTermsAndConditions.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createTermsAndConditions.rejected, (state, action: PayloadAction<string>) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTermsAndConditions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTermsAndConditions.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        const updatedTable = action.payload;
      })
      .addCase(updateTermsAndConditions.rejected, (state, action: PayloadAction<string>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default termsandconditionsSlice.reducer;
